<template>
  <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 md-small-size-100">
    <stats-card :header-color="color" footer-float="right">
      <template slot="header">
        <div class="card-icon">
          <md-icon>{{ icon }}</md-icon>
        </div>
        <p class="category">{{title}}</p>
        <h3 class="title">
          {{dataToShow}}
        </h3>
      </template>
      <template slot="footer">
        <div v-if="percChangeData.value">
          <span v-if="percChangeData.value > 0">
            <md-icon style="color: green;">keyboard_double_arrow_up</md-icon>
          </span>
          <span v-else-if="percChangeData.value < 0">
            <md-icon style="color: red;">keyboard_double_arrow_down</md-icon>
          </span>
          <span v-else> No Change - </span>
          {{ Math.abs(percChangeData.value) }} %
          <md-tooltip md-direction="bottom">
            <div>
              <p><strong>Previous Range:</strong></p>
              <p>{{ percChangeData.previous_range }}</p>
              
              <p><strong>Previous Count:</strong></p>
              <p>{{ percChangeData.previous_count }}</p>
            </div>
          </md-tooltip>
        </div>
        <loading-icon-button
          v-if="this.ableToViewApp ? (this.appIds.length > 0) : false"
          @click="emit(appIds)"
          tooltip="View Applications"
        >
          search
        </loading-icon-button>
        {{footer}}
      </template>
    </stats-card>
  </div>
</template>
<script>
import {StatsCard} from "../../../components";
import filters from "../../../components/utils/filters";
import LoadingIconButton from "@/components/LoadingIconButton";

export default {
  components: {
    StatsCard,
    LoadingIconButton,
  },
  props:{
    icon: {
      type: String,
      default: 'money',
    },
    color: {
      type: String,
      default: 'blue',
    },
    title: {
      type: String,
      default: ''
    },
    value: {
      type: String | Number,
      default: 0
    },
    filter:{
      type: String,
      default: null
    },
    footer:{
      type: String,
      default: null
    },
    appIds: {
      type: Array,
      default:null
    },
    ableToViewApp: {
      type: Boolean,
      default: false,
    },
    percChangeData: {
    type: Object,
      default: () => ({
        value: null,
        previous_range: null,
        previous_count: null
      })
    }
  },
  computed:{
    dataToShow(){
      if(this.filter){
        return filters[this.filter](this.value);
      }
      return this.value;
    }
  },
  methods:{
    ...filters,
    emit(data) {
      if (this.ableToViewApp && data.length > 0) {
        this.$emit('emit', data);
      }
    }
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
}
</script>
<style scoped lang="scss">
p.category {
  white-space: nowrap;
  overflow: hidden;
}
</style>